var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpenrouter = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#7624F4",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.654 3.521a5.087 5.087 0 0 1 0 10.175l5.046 5.046c.641.641.187 1.737-.719 1.737h-14.502a8.479 8.479 0 0 1 0-16.958ZM8.479 6.913a5.087 5.087 0 1 0 0 10.175a5.087 5.087 0 1 0 0-10.175Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpenrouter);
export default ForwardRef;